import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  value: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return { __sfc: true, }
}

})